module.exports = __webpack_public_path__ + "img/47.f10baf30.png";